import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;
export const price = (n) => `$${Number(n || 0) % 1 === 0 ? Number(n) : Number(n).toFixed(2)}`;

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d[0]?.msg || fallback;
  return fallback;
};

export const shortDate = (iso) => {
  const d = new Date(`${iso}T12:00:00`);
  return {
    month: d.toLocaleString("en-US", { month: "short" }),
    day: d.getDate(),
    year: d.getFullYear(),
    weekday: d.toLocaleString("en-US", { weekday: "short" }),
  };
};
